"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throwIfMissing;

function throwIfMissing() {
  throw new Error("Missing parameter");
}
//# sourceMappingURL=throwIfMissing.js.map


//////////////////
// WEBPACK FOOTER
// ./~/drift-zoom/lib/util/throwIfMissing.js
// module id = 115
// module chunks = 0